import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Products from "@/components/Products";
import Brands from "@/components/Brands";
import FAQ from "@/components/FAQ";
import Solar from "@/components/Solar";
import PowerBackup from "@/components/PowerBackup";
import Security from "@/components/Security";
import Broadband from "@/components/Broadband";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import CTASection from "@/components/CTASection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MobileCallBar from "@/components/MobileCallBar";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
    return (
        <div className="pb-[4.5rem] md:pb-0">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Products />
                <Brands />
                <Solar />
                <PowerBackup />
                <Security />
                <Broadband />
                <Services />
                <WhyUs />
                <Process />
                <FAQ />
                <CTASection />
                <Contact />
            </main>
            <Footer />
            <MobileCallBar />
            <WhatsAppButton />
        </div>
    );
}
